import Axios from '../config/Axios';

export function getMoveDocument(nDocumentId) {
  return Axios.get(`/document/form/move/${nDocumentId}`).then((oResponse) => oResponse.data);
}

export function moveDocument(nDocumentId, nFolderId) {
  return Axios.post('/document/move', { "nFolderId": nFolderId, "nDocumentId": nDocumentId });
}
